import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ProfileSection } from "@/components/settings/ProfileSection";
import { SharingSection } from "@/components/settings/SharingSection";
import { AccountGroupsSection } from "@/components/settings/AccountGroupsSection";
import { DreCategoryMappingSection } from "@/components/settings/DreCategoryMappingSection";
import { DangerZone } from "@/components/settings/DangerZone";
import { FeedbackSection } from "@/components/settings/FeedbackSection";
import { AccountsArchiveSection } from "@/components/settings/AccountsArchiveSection";
import { SubscriptionSection } from "@/components/settings/SubscriptionSection";
import { Palette, Moon, Sun, Monitor } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export default function Settings() {
  const { theme, setTheme } = useTheme();

  return (
    <div className="p-4 sm:p-6 space-y-6 w-full">
      <div>
        <h1 className="text-2xl font-bold">Configurações</h1>
        <p className="text-muted-foreground">Gerencie sua conta e preferências</p>
      </div>

      <Tabs defaultValue="perfil">
        <TabsList className="flex flex-wrap h-auto gap-1 w-full justify-start">
          <TabsTrigger value="perfil" className="text-xs sm:text-sm px-2 sm:px-3 py-1.5">Perfil</TabsTrigger>
          <TabsTrigger value="compartilhamento" className="text-xs sm:text-sm px-2 sm:px-3 py-1.5">Compartilhamento</TabsTrigger>
          <TabsTrigger value="grupos" className="text-xs sm:text-sm px-2 sm:px-3 py-1.5">Grupos de Contas</TabsTrigger>
          <TabsTrigger value="dre" className="text-xs sm:text-sm px-2 sm:px-3 py-1.5">DRE</TabsTrigger>
          <TabsTrigger value="assinatura" className="text-xs sm:text-sm px-2 sm:px-3 py-1.5">Assinatura</TabsTrigger>
          <TabsTrigger value="aparencia" className="text-xs sm:text-sm px-2 sm:px-3 py-1.5">Aparência</TabsTrigger>
          <TabsTrigger value="avancado" className="text-xs sm:text-sm px-2 sm:px-3 py-1.5">Avançado</TabsTrigger>
          <TabsTrigger value="feedback" className="text-xs sm:text-sm px-2 sm:px-3 py-1.5">Meu Feedback</TabsTrigger>
        </TabsList>

        <TabsContent value="perfil" className="mt-6">
          <ProfileSection />
        </TabsContent>

        <TabsContent value="compartilhamento" className="mt-6">
          <SharingSection />
        </TabsContent>

        <TabsContent value="grupos" className="mt-6">
          <AccountGroupsSection />
        </TabsContent>

        <TabsContent value="dre" className="mt-6">
          <DreCategoryMappingSection />
        </TabsContent>

        <TabsContent value="assinatura" className="mt-6">
          <SubscriptionSection />
        </TabsContent>

        <TabsContent value="aparencia" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <Palette className="h-5 w-5" />
                Aparência
              </CardTitle>
              <CardDescription>Escolha o tema da interface</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-3 gap-3">
                <Button
                  variant="outline"
                  className={cn(
                    "flex flex-col items-center gap-2 h-auto py-4",
                    theme === "light" && "border-primary bg-primary/5"
                  )}
                  onClick={() => setTheme("light")}
                >
                  <Sun className="h-5 w-5" />
                  <span className="text-xs">Claro</span>
                </Button>
                <Button
                  variant="outline"
                  className={cn(
                    "flex flex-col items-center gap-2 h-auto py-4",
                    theme === "dark" && "border-primary bg-primary/5"
                  )}
                  onClick={() => setTheme("dark")}
                >
                  <Moon className="h-5 w-5" />
                  <span className="text-xs">Escuro</span>
                </Button>
                <Button
                  variant="outline"
                  className={cn(
                    "flex flex-col items-center gap-2 h-auto py-4",
                    theme === "system" && "border-primary bg-primary/5"
                  )}
                  onClick={() => setTheme("system")}
                >
                  <Monitor className="h-5 w-5" />
                  <span className="text-xs">Sistema</span>
                </Button>
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="avancado" className="mt-6 space-y-6">
          <AccountsArchiveSection />
          <DangerZone />
        </TabsContent>

        <TabsContent value="feedback" className="mt-6">
          <FeedbackSection />
        </TabsContent>
      </Tabs>
    </div>
  );
}
